import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useFormik } from 'formik';

import { upsertPhysicalAsset } from 'api/PhysicalAssets';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';

import Modal from 'components/shared/Modal/Modal';
import Button from 'components/shared/Button/Button';
import Select from 'components/shared/Select/Select';
import PhysicalAssetKindBasic from 'components/Kiosk/components/PhysicalAssetKind/BasicAsset';
import PhysicalAssetKindTerminal from 'components/Kiosk/components/PhysicalAssetKind/Terminal';

import { PHYSICAL_ASSET_KIND, PHYSICAL_ASSET_KIND_OPTIONS } from '../constants';

const PhysicalAsset = ({ isOpen, title, handleClose, kioskId, data }) => {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      id: data?.id || undefined,
      physical_asset_kind_id: data?.physical_asset_kind_id || PHYSICAL_ASSET_KIND.unknown,
      data: data?.data || {},
      asset_tag: data?.asset_tag || ''
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      await upsertPhysicalAssetAsync(values);
    }
  });

  const { mutateAsync: upsertPhysicalAssetAsync, isPending: loading } = useCustomMutation({
    mutationFn: (values) => upsertPhysicalAsset(navigate, { kioskId, physicalAsset: values }),
    onSuccess: () => {
      formik.resetForm();
      handleClose();
    },
    onError: (error) => {
      console.error(error);
    },
    invalidateQueryKey: 'physical-assets-list'
  });

  return (
    <Modal
      isOpen={isOpen}
      title={title}
      handleClose={handleClose}
      className="max-h-[400px]"
      width="medium"
      overlayClassName="items-end"
      bodyClassName="h-full"
      slideFromBottom
      footer={
        <div className="flex w-full justify-between">
          <Button text="Cancel" variant="tertiary" onClick={handleClose} size="small" />
          <Button
            icon="save-mono"
            text="Save physical asset"
            onClick={formik.handleSubmit}
            isLoading={loading}
            color="primary"
            size="small"
          />
        </div>
      }>
      <div className="grid grid-cols-2 gap-3">
        <Select
          label="Asset"
          value={PHYSICAL_ASSET_KIND_OPTIONS.find(
            (o) => o.value === formik.values.physical_asset_kind_id
          )}
          name="physical_asset_kind_id"
          options={PHYSICAL_ASSET_KIND_OPTIONS}
          onChange={(value) => {
            formik.setFieldValue('physical_asset_kind_id', value?.value);
          }}
        />
        {formik.values.physical_asset_kind_id !== PHYSICAL_ASSET_KIND.terminal && (
          <PhysicalAssetKindBasic formik={formik} />
        )}
        {formik.values.physical_asset_kind_id === PHYSICAL_ASSET_KIND.terminal && (
          <PhysicalAssetKindTerminal formik={formik} />
        )}
      </div>
    </Modal>
  );
};

export default PhysicalAsset;
